import {createReducer} from 'store/config/creators';
import {TAction} from 'store/config/types';

import {PageInfoActions} from './page-info.constants';
import {IPageInfoState} from './page-info.types';

const pageInitialState: IPageInfoState = {
    currentEntityName: undefined,
    currentAdditionalEntityName: undefined,
};

export const pageInfoReducer = createReducer(pageInitialState, {
    [PageInfoActions.SET_CURRENT_PAGE_INFO]: (
        state: IPageInfoState,
        {payload}: TAction<IPageInfoState>,
    ) => ({...state, ...payload}),
    [PageInfoActions.RESET_CURRENT_PAGE_INFO]: (
        state: IPageInfoState,
    ) => ({...state, currentEntityName: undefined, currentAdditionalEntityName: undefined}),
});
